
<template>
  <div>
    <form v-on:submit.prevent="submitSearch">
      <div class="input-group input-group--search">
        <label for="input-search" class="input-group relative">
          <input
            type="text"
            class="input"
            id="input-search"
            :placeholder="$t('searchPlaceholderText')"
            v-model="query"
            v-on:blur="inputBlur"
            v-on:input="queryChange"
            autocomplete="off"
          >
          <div class="icon bg-white">
            <svg
              width="22px"
              height="22px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>Search Icon</title>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle
                  class="icon__circle"
                  stroke="#000000"
                  stroke-width="2"
                  fill-rule="nonzero"
                  cx="16.5"
                  cy="16.5"
                  r="12.5"
                ></circle>
                <path
                  class="icon__line"
                  d="M24.5,26.5 L34.0480957,36.0480957"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="square"
                  fill-rule="nonzero"
                ></path>
              </g>
            </svg>
          </div>
        </label>
        <div
          class="pl0 autocomplete-results absolute w-100"
          @mouseover="isHovering"
          @mouseleave="notHovering"
          v-show="isOpen"
        >
          <p class="ma0 suggestion-title pa3">{{$t('topArticlesTextZen')}}</p>
          <ul class="ma0 pa0">
            <router-link
              v-for="(result, i) in results"
              :key="i"
              class="no-underline"
              :to="{name: 'article', hash: getHash(result)}"
              v-on:click.native="closeSuggestions"
            >
              <li class="autocomplete-result f6 flex flex-row w100 ph3">
                <p class="ma0 autocomplete-result-title flex1">
                  <span class="pl1" v-html="result.htmlTitle"></span>
                  <span class="mv0 autocomplete-result-category">-</span>
                  <span class="mv0 mr2 autocomplete-result-category">{{result.category}}</span>
                </p>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  getLanguage,
  getPageHash,
  searchLocalArticles,
  formatArticleTitles,
  getCategoryIdByArticleId,
  getCategoryById
} from '@/utils/common';

export default {
  data: () => {
    return {
      query: '',
      articles: [],
      results: [],
      isOpen: false,
      hovering: false
    };
  },
  created: function() {
    const matches = this.$route.hash.match(new RegExp('query' + '=([^&]*)'));
    this.query = matches ? decodeURIComponent(matches[1]).replace(/\+/g, ' ') : null;
  },
  methods: {
    getHash(article) {
      return getPageHash(article);
    },
    submitSearch() {
      const lng = getLanguage();
      const urlQuery = this.query ? this.query.replace(/ /g, '+') : '';
      this.closeSuggestions();
      const newUrl = `/${lng}/search#query=${urlQuery}`;
      this.$router.push(newUrl);
      if (window.location.href.includes('search')) {
        this.$router.go(0);
      }
    },
    queryChange() {
      if (this.query === '') {
        this.isOpen = false;
        return;
      }
      this.filterResults();
    },
    filterResults() {
      const queries = this.query.split(' ').map(query => new RegExp(`(${query})`, 'i'));

      this.articles = searchLocalArticles(queries);
      const articles = formatArticleTitles(this.articles, this.query);

      const suggestions = articles.map(article => {
        const catId = getCategoryIdByArticleId(article.id);
        const { title } = getCategoryById(catId);
        return { ...article, category: title };
      });

      if (suggestions.length === 0) {
        this.results = [];
        this.isOpen = false;
        return;
      }
      this.isOpen = true;
      this.results = suggestions.slice(0, 6);
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    closeSuggestions() {
      this.isOpen = false;
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group--search {
  text-align: left;
  display: block;
  margin: 0 auto;
  max-width: 85%;
  width: 100%;
  border-radius: 3px;
  border: none;
  color: #8a8c83;
  background: #fff;
  position: relative;
  box-shadow: 0 9px 22px 0px rgba(39, 39, 39, 0.08);

  .input {
    border: 0;
    font-size: 16px;
    height: 60px;
    width: 100%;
    padding: 1rem;
    font-weight: 400;
    padding-left: 20px;
    color: #8a8c83;
    padding-left: 20px;
    outline: none;

    &::-webkit-input-placeholder {
      color: #8a8c83;
    }
    &:-moz-placeholder {
      color: #8a8c83;
    }
    &::-moz-placeholder {
      color: #8a8c83;
    }
    &:-ms-input-placeholder {
      color: #8a8c83;
    }
  }
  .icon {
    position: absolute;
    right: 1rem;
    top: 55%;
    transform: translateY(-50%);

    svg {
      .icon__circle,
      .icon__line {
        stroke: #828282;
      }
    }
  }
  &:focus {
    outline: none;
    border: none;
  }
}
.suggestion-title {
  border-bottom: 1px solid #f3f3f3;
}

@media (min-width: 426px) {
  .input-group--search {
    max-width: 45%;
  }
}

@media (min-width: 786px) {
  .input-group--search {
    max-width: 40%;
  }
  // .input-group--search {
  //   max-width: 40%;
  // }
}

//Results styles
.autocomplete-results {
  margin: 0;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow: auto;
  background-color: #fff;
  top: 5.8rem;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  cursor: pointer;
  color: #555;
  padding-top: 8px;
  padding-bottom: 8px;
}

.autocomplete-result-title {
  overflow: hidden;
  text-overflow: ellipsis;
  //   height: 24px;
  white-space: nowrap;
}


.autocomplete-result-category {
  color: #ccc;
  font-size: 80%;
  line-height: 19.6875px;
}

@media (min-width: 641px) and (max-width: 832px) {
  .input-group--search {
    max-width: 40%;
  }
}

*{
  font-family: 'Source Sans Pro',Arial, Helvetica, sans-serif!important;
  color:#fff!important;
}

html, body {
  background-color: #fbfbfb;
}

a {
  color: #F04682!important;
}

a:hover {
  border-color: #F04682!important;
}

.header {
  padding: 0 30px 30px 30px;
  background-color: #101218;
  margin-bottom:50px!important;
}

.sidebar .icon .polygon{
  fill: #F04682!important;
}
.sidebar a { color:#F04682!important;}
.sidebar span { color:#F04682!important;}
.input-group--search{
  background-color: transparent!important;
}


.input-group--search .input {
  border-radius: 5px;
  background-color: #ffffff;
  color:#101218!important;
  border: 1px solid rgba($color: #ffffff, $alpha: 0.1)!important;
  padding-left: 45px!important;
}

.input-group--search .input::placeholder { color: rgba($color: #101218, $alpha: 0.5)!important;}
.autocomplete-results {background-color: #31343E!important; border-color: rgba($color: #ffffff, $alpha: 0.1)!important;}

.input-group--search .icon {
  background-color: transparent!important;
  float: left!important;
  display: inline-block;
  left:1rem!important;
  top: 66%!important;
}

.category-boxes__item__link {
  background-color: #ffffff;
  color:#101218!important;
}
.category-boxes__item__link a, .category-boxes__item__link h3, .category-boxes__item__link p {
  color:#101218!important;
}

.category-boxes__item__link p { font-weight: 500;}

.category-boxes__item__link:hover {
  background-color:#fff!important;
  color:#101218!important;
}

.category-boxes__item__link:hover * {
  color:#101218!important;
}

h1.stage__title {
  text-transform: none!important;
}

.category-boxes__item__link .icon polygon, .category-boxes__item__link .icon path {
  fill: #F04682!important;
}

.footer__header {
  background-color: #ecece8!important;
  color: #101218!important;
  border : none!important;
}
.footer__header p { color:#101218!important;}

.footer__item__link {
  border-radius: 5px!important;
  border: 1px solid #ddddd9!important;
  background-color:#ffffff!important;
  color:#101218!important;
}

.footer__item__link h4 {
  color:#101218!important;
}

.footer__item__modals, .footer__item__modals h2{
  color:#101218!important;
}

.footer__modal-option::after {
  color:#F04682!important;
}

.footer__modal-link-text {
  background-color: #F04682!important;
}

.footer__modal-title{
  color: #101218!important;
}

.footer { margin-top: 140px!important;}



.language-dropdown__list .text, .language-dropdown__list .link { color:#101218!important; }

.ma0 { font-weight: 700; }
.stage__text .link { font-weight: 600;}

.content__main { padding:20px!important; border-radius: 5px; background-color: #ffffff; color:#101218!important; border: 1px solid #eeeeee;}
.articles .title { color:#101218!important; }
.content__main h1 { color:#101218!important; }
.article-body, .article-body * { color:#101218!important; font-weight: 600;}
.content__aside .sidebar__links { background-color: #fff; border: 1px solid #eeeeee; border-radius: 5px; position: relative; top:-50px;}
.footer__modal-option a { font-weight: 600!important;}
.footer__modal-link { border-radius: 5px; }

// Contact page,  Links in articles
.article-body, .article-body a { color:#F04682!important;}


.row-container * { color:#101218!important}
.row-container a { color:#F04682!important}
.stage__text .stage__text__question { color:#fff!important; }
.input-group--btns { margin: 5px 0 20px!important; padding:0!important}
.input-group--btns button {background-color: #F04682!important; color:#fff!important; font-weight: 600!important;}
.autocomplete-result-title:hover{
  color: #F04682 !important;
}
</style>
